import React from "react";

type AnimationLoadingProps = {
    isLoading: boolean;
    text?: string; // Text est optionnel
};

const AnimationLoading: React.FC<AnimationLoadingProps> = ({ isLoading, text }) => {
    return (
        <>
            <div className={`${isLoading ? 'chargementRegisterHl' : 'chargementRegisterHlNone'}`}>
                <div className="overlay"></div>
                <div className="spinner"></div>
                {text &&
                    <p>
                        Enregistrement de la prestation en cours.
                    </p>
                }
            </div>
        </>
    );
};

export default AnimationLoading;
